<template>
	<div>
		<q-table :data="data" :columns="columns" :pagination.sync="server_pagination" @request="request"
			:loading="loading" row-key="id" :no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')" :loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')" :rows-per-page-options="[0]" binary-state-sort class="q-mt-md">
			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props" :props="props">
				<q-td auto-width key="move" :props="props">
					<q-btn flat round color="primary" icon="fas fa-arrow-up" @click="moveItem(props, 'up')"
						:disable="!managerTrainings" />
					<q-btn flat round color="negative" icon="fas fa-arrow-down" @click="moveItem(props, 'down')"
						:disable="!managerTrainings" />
				</q-td>

				<q-td key="hierarchy_order" :props="props">
					{{ props.row.hierarchy_order }}
					<q-popup-edit v-model="props.row.hierarchy_order" @hide="reorderItems(props.row)">
						<q-input v-model="new_order" type="number" />
					</q-popup-edit>
				</q-td>

				<q-td key="type_slug" :props="props">
					<q-icon :name="getIconName(props.row.type_slug)" size="1.2rem" />
					{{ $t(props.row.type_slug) }}
				</q-td>

				<q-td key="type_title" :props="props">
					{{ props.row.type_title }}
				</q-td>

				<q-td key="parent_id" :props="props">
					<q-select v-model="props.row.parent_id" :options="getOptions(props.row)" @input="saveConfigure()"
						clearable :disable="!managerTrainings" />
				</q-td>

				<q-td key="type_avaliable_in" :props="props">
					{{ fDate(props.row.type_avaliable_in) }}
				</q-td>

				<q-td key="type_score" :props="props">
					{{ props.row.type_score }}
				</q-td>
			</q-tr>
		</q-table>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3 text-right">
				<p class="caption">
					{{ $t('open_training') }}
					<q-icon name="far fa-question-circle" class="cursor-pointer"
						@click.native="show_training_in_progress_helper = true" />
				</p>
				<q-btn-toggle v-model="is_open" :toggle-color="getColorIsOpen" :options="is_open_options"
					@input="changeIsOpen()" :disable="disableIsOpen" />
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_trainings' })" />
			</div>

			<div class="col-xs-12 col-sm-3">
				<q-btn color="negative" class="full-width" :label="$t('unpublish')" icon="fas fa-ban"
					@click="unpublish()" :disable="!managerTrainings">
					<q-tooltip v-if="!managerTrainings">
						{{ $t('not_allowed') }}
					</q-tooltip>
				</q-btn>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn color="positive" class="full-width" :label="$t('publish')" icon="fas fa-upload"
					@click="publish()" :disable="!managerTrainings">
					<q-tooltip v-if="disableButtons">
						{{ $t('no_modules_or_tests_on_training') }}
					</q-tooltip>
				</q-btn>
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-sm">
			<div class="col-xs-12 col-sm-3">
				<q-btn color="info" class="full-width" :label="$t('duplicate_training')" icon="far fa-copy"
					@click="show_confirm_duplicate = true" :disable="!managerTrainings" />
			</div>
		</div>

		<q-dialog v-model="show_alert_change" @ok="saveChangeIsOpen">
			<span slot="title">{{ $t('close_training') }}
				<q-icon name="far fa-question-circle" class="cursor-pointer"
					@click.native="show_training_in_progress_helper = true" />
			</span>

			<span slot="message">{{ $t('confirm_close_training_this_cannot_be_undone') }}</span>

			<template slot="buttons" slot-scope="props">
				<q-btn color="tertiary" :label="$t('cancel')" @click="cancelChangeIsOpen()" />
				<q-btn color="primary" :disable="countDown > 0" @click="saveChangeIsOpen()">{{ $t('confirm') }} ({{
			countDown }}) </q-btn>
			</template>
		</q-dialog>

		<q-dialog v-model="show_confirm_duplicate" @ok="duplicateTraining">
			<span slot="title">{{ $t('duplicate_training') }}</span>

			<span slot="message">{{
			$t('confirm_duplicate_the_training_and_all_its_contents')
		}}</span>

			<template slot="buttons" slot-scope="props">
				<q-btn color="tertiary" :label="$t('cancel')" @click="show_confirm_duplicate = false" />
				<q-btn color="positive" :label="$t('confirm')" @click="duplicateTraining()" />
			</template>
		</q-dialog>

		<q-dialog v-model="show_training_in_progress_helper" @ok="handleIsOpen">
			<span slot="title">{{ $t('open_training') }}</span>
			<span slot="message">{{ $t('open_training_helper') }}</span>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from 'quasar'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
	props: ['managerTrainings'],

	data() {
		return {
			id_training: '',
			countDown: 0,
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 0,
				descending: false,
				sortBy: 'hierarchy_order',
			},
			data: [],
			columns: [
				{
					name: 'move',
					required: true,
					label: '',
					align: 'left',
					field: 'move',
					sortable: false,
				},
				{
					name: 'hierarchy_order',
					required: true,
					label: 'order',
					align: 'left',
					field: 'hierarchy_order',
					sortable: false,
				},
				{
					name: 'type_slug',
					required: true,
					label: 'type',
					align: 'left',
					field: 'type_slug',
					sortable: false,
				},
				{
					name: 'type_title',
					required: true,
					label: 'title',
					align: 'left',
					field: 'type_title',
					sortable: false,
				},
				{
					name: 'parent_id',
					required: true,
					label: 'prerequisite',
					align: 'left',
					field: 'parent_id',
					sortable: false,
				},
				{
					name: 'type_avaliable_in',
					required: true,
					label: 'avaliable_in',
					align: 'left',
					field: 'type_avaliable_in',
					sortable: false,
				},
				{
					name: 'type_score',
					required: true,
					label: 'score',
					align: 'left',
					field: 'type_score',
					sortable: false,
				},
			],
			loading: false,
			parents: [],
			new_order: '',
			is_open: false,
			is_open_options: [
				{ label: this.$t('yes'), value: true },
				{ label: this.$t('no'), value: false },
			],
			show_alert_change: false,
			training: [],
			show_confirm_duplicate: false,
			show_training_in_progress_helper: false,
			is_dialog_closed: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_language_selected: 'common/id_user_language_selected',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		disableButtons() {
			if (this.managerTrainings) {
				if (this.data.length == 0) return true
				else return false
			} else return true
		},

		getColorIsOpen() {
			if (this.is_open) return 'primary'
			else return 'tertiary'
		},

		disableIsOpen() {
			if (!this.is_open && this.training.has_done_activities) return true
			else if (this.is_open && this.training.has_done_activities) return false
			else return false
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				search: this.filter,
				ordering: order_by,
			}

			this.$axios
				.get(
					`/admin_group_trainings/group_trainings/${this.id_training
					}/group_training_hierarchy/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					this.data = []
					this.parents = []

					response.data.forEach((result) => {
						this.data.push({
							type_id: result.type_id,
							move: result.type_slug + result.type_id,
							hierarchy_order: result.hierarchy_order,
							type_slug: result.type_slug,
							type_title: result.type_title,
							parent_id: result.parent_id
								? result.parent_slug + result.parent_id
								: null,
							parent_slug: result.parent_slug,
							type_avaliable_in: result.type_avaliable_in,
							type_score: result.type_score != 0 ? result.type_score : '',
						})

						this.parents.push({
							value: result.type_slug + result.type_id,
							label: result.type_title,
							type_slug: result.type_slug,
							id: result.type_id,
						})
					})

					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(
					'/admin_group_trainings/group_trainings/' + this.id_training + '/',
					this.getHeader
				)
				.then((response) => {
					this.training = response.data
					this.is_open = response.data.is_open

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
					this.$router.push({ name: 'admin_trainings' })
				})
		},

		saveConfigure() {
			let data = []

			this.data.forEach((element) => {
				data.push({
					hierarchy_order: element.hierarchy_order,
					type_slug: element.type_slug,
					type_title: element.type_title,
					type_id: element.type_id,
					parent_id: this.getParentId(element.parent_id),
					parent_slug: this.getParentSlug(element.parent_id),
					type_avaliable_in: element.type_avaliable_in
						? date.formatDate(element.type_avaliable_in, 'DD/MM/YYYY')
						: '',
					type_score: element.type_score != 0 ? element.type_score : '',
				})
			})

			this.$axios
				.post(
					`/admin_group_trainings/group_trainings/${this.id_training
					}/group_training_hierarchy/`,
					data,
					this.getHeader
				)
				.then((response) => {
					let data = []
					let parents = []

					response.data.forEach((result) => {
						data.push({
							type_id: result.type_id,
							move: result.type_slug + result.type_id,
							hierarchy_order: result.hierarchy_order,
							type_slug: result.type_slug,
							type_title: result.type_title,
							parent_id: result.parent_id
								? result.parent_slug + result.parent_id
								: null,
							parent_slug: result.parent_slug,
							type_avaliable_in: result.type_avaliable_in,
							type_score: result.type_score != 0 ? result.type_score : '',
						})

						parents.push({
							value: result.type_slug + result.type_id,
							label: result.type_title,
							type_slug: result.type_slug,
							id: result.type_id,
						})
					})

					this.data = data
					this.parents = parents

					this.$q.notify({
						message: this.$t('configure_edit_success'),
						type: 'positive',
						icon: 'far fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
				})
		},

		publish() {
			this.$q.loading.show()

			let fd = new FormData()

			this.$axios
				.post(
					`/admin_group_trainings/group_trainings/${this.id_training}/publish/`,
					fd,
					this.getHeader
				)
				.then((response) => {
					this.$q.loading.hide()
					this.$router.push({ name: 'admin_trainings' })
				})
				.catch((e) => {
					this.loading = false
					this.$q.loading.hide()
					console.log(e)

					this.$q.notify({
						message: this.$t(
							'to_publish_the_training_it_must_have_at_least_one_class_or_test'
						),
						type: 'negative',
						icon: 'fas fa-ban',
					})
				})
		},

		unpublish() {
			this.$q.loading.show()

			let fd = new FormData()

			this.$axios
				.post(
					`/admin_group_trainings/group_trainings/${this.id_training}/unpublish/`,
					fd,
					this.getHeader
				)
				.then((response) => {
					this.$q.loading.hide()
					this.$router.push({ name: 'admin_trainings' })
				})
				.catch((e) => {
					this.loading = false
					this.$q.loading.hide()
					console.log(e)
				})
		},

		moveItem(item, direction) {
			if (direction == 'up' && item.row.hierarchy_order > 1) item.row.hierarchy_order--
			else if (direction == 'down' && item.row.hierarchy_order < this.data.length)
				item.row.hierarchy_order++

			let obj = this.data.find((obj) => {
				return (
					obj.move !== item.row.move && obj.hierarchy_order === item.row.hierarchy_order
				)
			})

			if (obj) {
				if (direction == 'up') {
					obj.hierarchy_order++
				}
				if (direction == 'down') {
					obj.hierarchy_order--
				}
			}

			this.saveConfigure()
		},

		getIconName(slug) {
			if (slug == 'module') return 'fas fa-clipboard-check'
			else if (slug == 'test') return 'fas fa-chalkboard-teacher'
			else if (slug == 'game') return 'fas fa-gamepad'
		},

		getOptions(row) {
			let options = []
			let selected = []
			let quantity_selected = 0

			this.data.forEach((element) => {
				if (element.parent_id) {
					selected.push({
						id: element.parent_id,
						origin: element.move,
					})
					quantity_selected++
				}
			})

			this.parents.forEach((parent) => {
				let is_selected = selected.find((obj) => {
					return obj.origin === parent.value
				})

				if (row.parent_id || quantity_selected < this.data.length - 1) {
					if (row.move != parent.value) {
						if (!is_selected) {
							options.push({
								value: parent.value,
								label: parent.label,
								type_slug: parent.type_slug,
							})
						} else if (is_selected.id != row.move) {
							options.push({
								value: parent.value,
								label: parent.label,
								type_slug: parent.type_slug,
							})
						}
					}
				}
			})
			return options
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		getParentSlug(id) {
			let obj = this.parents.find((obj) => {
				return obj.value === id
			})
			if (obj) return obj.type_slug
			else return null
		},

		getParentId(id) {
			let obj = this.parents.find((obj) => {
				return obj.value === id
			})
			if (obj) return obj.id
			else return null
		},

		reorderItems(row) {
			if (this.new_order > 0 && this.new_order <= this.data.length) {
				if (row.hierarchy_order > this.new_order) {
					this.data.forEach((data) => {
						if (
							data.move != row.move &&
							data.hierarchy_order < row.hierarchy_order &&
							data.hierarchy_order >= this.new_order
						) {
							if (data.hierarchy_order + 1 <= this.data.length) data.hierarchy_order++
						}
					})
				} else if (row.hierarchy_order < this.new_order) {
					this.data.forEach((data) => {
						if (
							data.move != row.move &&
							data.hierarchy_order > row.hierarchy_order &&
							data.hierarchy_order <= this.new_order
						) {
							if (data.hierarchy_order - 1 > 0) data.hierarchy_order--
						}
					})
				}

				row.hierarchy_order = this.new_order
				this.saveConfigure()
			}
			this.new_order = ''
		},

		countDownTimer() {
			let timeOut
			if (this.countDown > 0) {
				timeOut = setTimeout(() => {
					this.countDown -= 1
					this.countDownTimer()
				}, 1000)
			} else {
				clearTimeout(timeOut)
			}
		},

		handleIsOpen() {
			this.show_training_in_progress_helper = false
		},

		changeIsOpen() {
			if (!this.is_open && this.training.has_done_activities) {
				this.is_dialog_closed = true
				this.show_alert_change = true
				this.countDown = 5
				this.countDownTimer()
				if (this.training.has_done_activities) this.show_alert_change = true
			} else {
				this.saveChangeIsOpen()
			}
		},

		saveChangeIsOpen() {
			let fd = new FormData()
			fd.append('is_open', this.is_open)

			this.$axios
				.post(
					`/admin_group_trainings/group_trainings/${this.id_training}/change_is_open/`,
					fd,
					this.getHeader
				)
				.then((response) => {
					this.show_alert_change = false

					this.$q.notify({
						message: this.$t('open_training_change_success'),
						type: 'positive',
						icon: 'far fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
					this.$q.notify({
						message: this.$t('open_training_change_error'),
						type: 'negative',
						icon: 'fas fa-ban',
					})
				})
		},

		cancelChangeIsOpen() {
			this.is_open = true
			this.show_alert_change = false
		},

		duplicateTraining() {
			this.show_confirm_duplicate = false
			this.$q.loading.show()

			this.$axios
				.get(
					`/admin_group_trainings/group_trainings/${this.id_training}/duplicate/`,
					this.getHeader
				)
				.then((response) => {
					this.$router.push({
						name: 'admin_training',
						params: { id: response.data.group_training_duplicated_id },
					})

					this.$emit('duplicate')

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY'
						break
					default:
						format = 'MM-DD-YYYY'
						break
				}

				return moment(d)
					.tz('Etc/GMT')
					.format(format)
			}
		},
	},

	created() {
		this.id_training = this.$route.params.id
		this.fetchData()

		this.request({
			pagination: this.server_pagination,
		})
	},
}
</script>
